import { Document, Page, Text, View } from '@react-pdf/renderer'
import { createTw } from 'react-pdf-tailwind'
import { UnemployedGraduate } from './UnemployedGraduates'
import { splitArrayIntoChunks } from '../../../helpers/utils'

const tw = createTw({
    theme: {
        fontFamily: {
            sans: ['Comic Sans'],
        },
        extend: {
            colors: {
                custom: '#bada55',
            },
        },
    },
})

const UnemployedGraduatesPDF = ({ data }: { data: UnemployedGraduate[] }) => {
    return (
        <Document>
            <Page size={'A4'}>
                <View style={tw('flex flex-col px-4 w-full text-sm')}>
                    <Text style={tw('text-3xl pt-5 text-[#333752] underline text-center')}>
                        Graduados sin empleo
                    </Text>
                    {splitArrayIntoChunks(data, 6).map((chunk: UnemployedGraduate[], index) => (
                        <View
                            break={index > 0}
                            style={index > 0 ? tw('pt-12') : {}}
                        >
                            {chunk.map((graduate) => (
                                <View
                                    style={tw('flex flex-col w-full text-lg')}
                                    key={graduate.email}
                                >
                                    <Text>
                                        Nombre: {graduate.firstName + ' ' + graduate.lastName}
                                    </Text>
                                    <Text>Email: {graduate.email}</Text>
                                    <Text>Teléfono: {graduate.phone}</Text>
                                    <Text>Aptitudes: {graduate.abilities.join(', ')}</Text>
                                    <View
                                        style={{
                                            borderBottomWidth: 1,
                                            width: '100%',
                                            marginTop: '3px',
                                            marginBottom: '8px',
                                        }}
                                    />
                                </View>
                            ))}
                        </View>
                    ))}
                </View>
            </Page>
        </Document>
    )
}

export default UnemployedGraduatesPDF
